import { render } from "./ActionsMessages.vue?vue&type=template&id=54fd3790"
import script from "./ActionsMessages.vue?vue&type=script&lang=js"
export * from "./ActionsMessages.vue?vue&type=script&lang=js"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__